<script>
    // paramètres bind
    export let timeReaction;
</script>

<style>
    .last-result {
        @apply grid m-auto pb-2 w-4/5;
    }
</style>

<div class="last-result">
    <div class="flex justify-center items-end">
        {#if timeReaction > 0}
            <span class="text-3xl font-normal">{timeReaction}</span><span class="text-xl font-normal ml-1">ms</span>
        {/if}
    </div>
</div>